module.exports = __webpack_public_path__ + "c257c72f11a222936aa79253b6bce571.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/festival02.jpg
// module id = 652
// module chunks = 0